import { render, staticRenderFns } from "./right-nav.vue?vue&type=template&id=5b9461a7&scoped=true"
import script from "./right-nav.vue?vue&type=script&lang=js"
export * from "./right-nav.vue?vue&type=script&lang=js"
import style0 from "./right-nav.vue?vue&type=style&index=0&id=5b9461a7&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9461a7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b9461a7')) {
      api.createRecord('5b9461a7', component.options)
    } else {
      api.reload('5b9461a7', component.options)
    }
    module.hot.accept("./right-nav.vue?vue&type=template&id=5b9461a7&scoped=true", function () {
      api.rerender('5b9461a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trade/right-nav.vue"
export default component.exports